<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Branch</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="balance.branch" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Currency</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select v-model="balance.currency">
                <option v-for="c in currencies" :value="c.id">{{c.id}} ({{c.symbol}})</option>
              </select>
            </div>
          </div>
          <p class="help is-danger" v-if="!$v.balance.currency.required">Currency is required</p>
        </div>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <button class="button is-primary" @click="create()" :disabled="$v.$invalid">Create</button>
      </div>
    </div>
  </div>
</template>
<script>
  import state from '../../../../../state'
  import balanceService from '../../../../../services/balance.service'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'balance-create',
    data() {
      return {
        balance: {
          branch: null,
          currency: null
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      },
      playerId() {
        return this.$route.params.playerId;
      },
      currencies() {
        return state.currencies.get();
      }
    },
    validations: {
      balance: {
        currency: {
          required
        }
      }
    },
    methods: {
      async create() {
        this.balance.clientId = this.clientId;
        this.balance.userId = this.playerId;
        await balanceService.create(this.balance);
        this.$router.push({ name: 'player', params: { playerId: this.playerId } });
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/players/player/create-balance.vue